import React from 'react';
import MedicationLandingPage from '../components/MedicationLandingPage';

const data = {
  slug: 'hydrocortisone',
  etsyUrl: 'https://www.etsy.com/shop/MyGuardPod?ref=seller-platform-mcnav&section_id=57806739',
  en: {
    title: 'CortoPod Protective Carrying Case',
    subtitle: 'Purpose-built carrying case format designed to fit emergency hydrocortisone injection kit containers and supplies.',
    aboutTitle: 'About emergency hydrocortisone kits',
    aboutText: 'Emergency hydrocortisone sodium succinate injection kits are prescribed to individuals living with adrenal insufficiency for use during an adrenal emergency as directed by their healthcare professional. Kit contents, indications, dosage and administration instructions are established by the medication manufacturer and by the user\u2019s healthcare professional.',
    whyTitle: 'Why a fitted carrying case',
    whyText: 'Emergency hydrocortisone kits typically include a glass vial, syringe, needles and small supplies. A fitted carrying case can help keep the container and supplies organized, visible and identified during everyday carry.',
    whyPoints: [
      'Format-specific organization',
      'Highly visible identification',
      'Fitted layout for the specific listed medication format',
      'Added physical barrier during everyday carry',
      'Quick-opening carrying-case design',
      'Made to order in Qu\u00e9bec, Canada',
      'Medication and medical supplies not included',
    ],
    howTitle: 'What the CortoPod is',
    howText: 'The CortoPod is a protective carrying case format designed to contain, organize, identify and transport a compatible emergency hydrocortisone injection kit container and supplies. It does not administer, dose, monitor, preserve or modify the medication.',
    ctaTitle: 'Get your CortoPod',
  },
  fr: {
    title: '\u00c9tui protecteur CortoPod',
    subtitle: 'Format d\u2019\u00e9tui de transport con\u00e7u pour accueillir un contenant de kit d\u2019hydrocortisone injectable d\u2019urgence et son mat\u00e9riel.',
    aboutTitle: '\u00c0 propos des kits d\u2019hydrocortisone d\u2019urgence',
    aboutText: 'Les kits d\u2019injection de succinate sodique d\u2019hydrocortisone d\u2019urgence sont prescrits aux personnes atteintes d\u2019insuffisance surr\u00e9nalienne pour \u00eatre utilis\u00e9s en cas d\u2019urgence surr\u00e9nalienne selon les directives de leur professionnel de la sant\u00e9. Le contenu du kit, les indications, la posologie et les instructions d\u2019administration sont \u00e9tablis par le fabricant du m\u00e9dicament et par le professionnel de la sant\u00e9 de l\u2019utilisateur.',
    whyTitle: 'Pourquoi un \u00e9tui ajust\u00e9',
    whyText: 'Les kits d\u2019hydrocortisone d\u2019urgence incluent g\u00e9n\u00e9ralement une fiole de verre, une seringue, des aiguilles et de petites fournitures. Un \u00e9tui ajust\u00e9 peut aider \u00e0 garder le contenant et le mat\u00e9riel organis\u00e9s, visibles et identifi\u00e9s pendant le transport quotidien.',
    whyPoints: [
      'Organisation adapt\u00e9e au format',
      'Identification tr\u00e8s visible',
      'Am\u00e9nagement ajust\u00e9 au format de m\u00e9dicament indiqu\u00e9',
      'Barri\u00e8re physique ajout\u00e9e pendant le transport quotidien',
      'Ouverture rapide de l\u2019\u00e9tui',
      'Fabriqu\u00e9 sur commande au Qu\u00e9bec, Canada',
      'M\u00e9dicament et mat\u00e9riel m\u00e9dical non inclus',
    ],
    howTitle: 'Qu\u2019est-ce que le CortoPod',
    howText: 'Le CortoPod est un format d\u2019\u00e9tui de transport protecteur con\u00e7u pour contenir, organiser, identifier et transporter un contenant compatible de kit d\u2019hydrocortisone d\u2019urgence et son mat\u00e9riel. Il n\u2019administre, ne dose, ne surveille, ne conserve et ne modifie aucun m\u00e9dicament.',
    ctaTitle: 'Obtenez votre CortoPod',
  },
};

const HydrocortisoneCasePage = () => <MedicationLandingPage medication={data} />;
export default HydrocortisoneCasePage;
